<template>
  <div class="dotted-bg">

    <DemoNotice :isInDemoMode="isInDemoMode" />

    <div class="d-flex pa-4">
      <div>
        <StatsConvTo />
      </div>

      <div class="flex-grow-1 d-flex flex-column">
        <v-card
          outlined
          class="pa-8 ma-1 d-flex flex-column"
          style="width:100%; height: 20rem; min-height: 200px; max-height: 40rem;"
        >
          <div class="flex-grow-1 d-flex flex-column justify-center">
            <div class="display-2 font-weight-bold">
              {{ dashboardInfo.name }}
            </div>
            <div class="display-1 font-weight-light">
              6 participants
            </div>
            <div class="display-1 font-weight-light">
              3 locations
            </div>
            <div class="display-1 font-weight-light">
              6,243 items
            </div>
          </div>
        </v-card>
  
        <v-card
          color="primary"
          class="pa-8 ma-1 d-flex flex-column"
          style="width:100%; height: 20rem; min-height: 100px; max-height: 20rem;"
        >
          <div class="pa-2" id="txn-chart" style="height: 100%">
          </div>
        </v-card>

        <div class="flex-grow-1 d-flex flex-column">
          <v-timeline>
            <v-timeline-item
              v-for="(txn, txnIdx) of txnDataArray.txns"
              :key="txnIdx"
              :class="`pa-4 ${txnIdx % 2 === 0 ? '' : 'text-right'}`"
            >
              <div class="">
                <span class="display-1">
                  {{ txn.changeQty }}
                </span>
                <span class="display-0 font-weight-bold">
                  {{ txn.changeUts }}
                </span>
              </div>
              <div class="text-h6 font-weight-bold">
                {{ txn.matLbl }}
              </div>
              {{ txn.timestamp | moment  }}
            </v-timeline-item>
          </v-timeline>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import moment from "moment";
import Plotly from "plotly.js";
import { layout, bar } from "plotly-js-material-design-theme";
import * as bkpData from "@/utils/bkpData";
import * as convUtils from "@/utils/convUtils";
import DemoNotice from "@/components/DemoNotice";
import StatsConvTo from "@/components/StatsConvTo";


export default {
  components: {
    DemoNotice,
    StatsConvTo
  },
  data() {
    return {
      dashboardInfo: {},
      boardData_multi: [],
      fb_items_multi: [],
      materialPoolInfo: [],
      txnDataArray: {
        txns: []
      },
      isInDemoMode: false,
    }
  },
  filters: {
    moment: function (date) {
      return moment(date).format("MMM Do YY");
    }
  },
  async mounted() {

    let that = this;

    let FORCE_LOAD_DEMO = false;
    // FORCE_LOAD_DEMO = true;

    if (window.location.pathname.toLowerCase().startsWith("/demo") || FORCE_LOAD_DEMO) {
      console.log("Running demo");
      that.boardData_multi = bkpData.boardData_multi;
      that.fb_items_multi = bkpData.fb_items_multi;
      that.isInDemoMode = true;
      await this.extractMatData();
      return;
    }


    if (!this.isInMonday) return;

    await this.monday_Init();

  },
  methods: {
    async monday_Init() {
      let that = this;

      that.monday.listen("context", async (res) => {
        let mDayRes = await that.monday.api(
          `query ($boardIds: [Int]) {
            boards (ids:$boardIds) {
              name
              id
              items {
                name
                id
                column_values { title text }
              }
            }
          }`,
          { variables: {boardIds: res.data.boardIds} }
        );
        console.log(mDayRes.data);
        that.boardData_multi = mDayRes.data.boards;
        that.dashboardInfo = mDayRes.data;

        await this.readStoredEntities();
        await this.extractMatData();
      });

    },

    async readStoredEntities() {

      let that = this;

      let readFn = async (itemWrapperObj) => {
        let item = itemWrapperObj.bdItem;
        let bdData = itemWrapperObj.bdData;
        let entityId = `b_${bdData.id}_i_${item.id}_v_0`;
        let readObj = await entitySvc.getEntity({ entityId });
        readObj.entityId = entityId;
        return readObj;
      }

      let arrOfItemArr = that.boardData_multi.map(bd => {
        return bd.items.map(it => {
          return {
            bdData: bd,
            bdItem: it
          };
        });
      });
      arrOfItemArr = arrOfItemArr.flat();
      let readObjs = await utils.getResultsInParallel(arrOfItemArr, readFn);
      
      that.fb_items_multi = readObjs
        .filter(readObj => 
                    readObj.status === "fulfilled"
                  && typeof readObj.value === 'object'
                  && readObj.value !== null
                )
        .map(readObj => readObj.value);

    },
    
    async extractMatData() {
      let matToPoolInfoDict = convUtils.getRecoverableMatResourcesInfo(this.fb_items_multi);
      this.materialPoolInfo = Object.values(matToPoolInfoDict);
      console.log(this.materialPoolInfo);

      let txnDataArray = convUtils.extractTxnArray(this.materialPoolInfo);
      this.txnDataArray = txnDataArray;
      console.log(this.txnDataArray);


      let txnsChart = bar({
        x: txnDataArray.txns.map((t, idx) => idx + 1),
        y: txnDataArray.txns.map(t => t.changeQty),
        type: "bar",
        marker: {
          color: "white",
        },
        insidetextfont  : {
          color: "white",
        }
      });
      let l = layout({
        title: "Chart",
        font: {
          color: "white",
          family: "Roboto"
        },
        paper_bgcolor: 'rgba(0,0,0,0)',
        plot_bgcolor: 'rgba(0,0,0,0)',
      });

      Plotly.newPlot("txn-chart", [txnsChart], l);
    }
  }
}
</script>

<style scoped>
.dotted-bg {
  background-image: radial-gradient(#c3c6d4 7%, #ffffff 7%);
  background-position: 0 0;
  background-size: 60px 60px;
  height: 100%;
  width: 100%;
  background-repeat: repeat;
}
</style>